import React, { useState, useEffect } from "react";

/* desktop (card) version */
import PodcastPage from "./PodcastPage";
import PodcastPageV2 from "./PodcastPageV2";

export default function PodcastPageWrapper() {
  /* treat ≤ 767 px wide as “mobile” */
  const getMatch = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 767px)").matches;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mq = window.matchMedia("(max-width: 767px)");
    const onChange = (e) => setIsMobile(e.matches);

    /* modern + legacy listeners */
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else                     mq.addListener(onChange);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else                        mq.removeListener(onChange);
    };
  }, []);

  return isMobile ? <PodcastPageV2 /> : <PodcastPage />;
}